export default __webpack_public_path__ + "static/media/Char0.3a939ed4.png";